<template>
  <v-card>
    <v-card-title>
      Varování
    </v-card-title>
    <v-card-actions>
      <v-btn small color="primary" outlined @click="exportCsv">Export CSV</v-btn>
    </v-card-actions>
    <v-card-text>
      <data-search
          @search="getData"
          @input="search = $event"/>
    </v-card-text>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1">
      <template #item.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.expiration="{ item }">
        {{ formatExpiration(item) }}
      </template>
      <template #item.action="{ item }">
        <v-btn v-if="item.cleaningService" outlined small color="primary" exact :to="'/app/cleaning-services/' + item.cleaningService">
          Úklidová služba
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {formatDatetime} from '@/helper/date-helper'
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'

export default {
  name: "UserWarningsTable",
  props: {
    userId: {},
  },
  data() {
    return {
      headers: [
        {text: 'ID', value: 'id'},
        {text: 'Uklízecí služba', value: 'cleaningServiceName', sortable: false},
        {text: 'Adresa uklizecí služby', value: 'cleaningServiceAddress', sortable: false},
        {text: 'Zákazník', value: 'cleaningServiceCustomer', sortable: false},
        {text: 'Popis', value: 'description'},
        {text: 'Typ', value: 'type'},
        {text: 'Expirace', value: 'expiration'},
        {text: 'Vytvořeno', value: 'createdAt'},
        {text: 'Akce', value: 'action', sortable: false}
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50, 100, 250, 500, 1000]
      },
      data: null,
      search: null
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.totalElements
    },
    items() {
      if (!this.data) return []
      return this.data.content
    }
  },
  methods: {
    getData() {
      const params = generateRequestParams(
          this.options.page,
          this.options.itemsPerPage,
          this.search,
          this.options.sortBy,
          this.options.sortDesc
      )
      params.append('user', this.userId)
      this.axios.get('/api/admin/warning', {
        params: params
      })
          .then(({data}) => {
            this.data = data
          })
    },
    formatCreatedAt({createdAt}) {
      return formatDatetime(createdAt)
    },
    formatExpiration({expiration}) {
      return formatDatetime(expiration)
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'user-warnings')
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>